import React from 'react';
import './_styles.scss';
import { UserPermissions } from '../../../../../src/definitions';
import { securityService } from '../../../../../src/_global/services';

interface FancyCardProps {
  data?: any;
}

export default function FancyCard({ data }: FancyCardProps) {
  const { name } = data;

  return securityService.checkRoleAccess(UserPermissions.viewReports) ? (
    <p className='fancy-card'>{name}</p>
  ) : (
    <p></p>
  );
}
